/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs */

const en__field__enum_additionalstudyinterests_study_bioinformatics21 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatics`)
};

const de__field__enum_additionalstudyinterests_study_bioinformatics21 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatik`)
};

/**
* | output |
* | --- |
* | "Bioinformatics" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_bioinformatics21 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Bioinformatics21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_bioinformatics21(inputs)
	return de__field__enum_additionalstudyinterests_study_bioinformatics21(inputs)
});
export { _field__enum_additionalstudyinterests_study_bioinformatics21 as "_field__enum_additionalStudyInterests_STUDY_BIOINFORMATICS" }